export default {
  namespaced: true,
  state: {
    period: {
      from: '',
      to: ''
    },
    periodName: ''
  },
  getters: {
    getPeriod (state) {
      return state.period
    },
    getPeriodName (state) {
      return state.periodName
    }
  },
  mutations: {
    setPeriod (state, period) {
      state.period = period
    },
    setPeriodName (state, periodName) {
      state.periodName = periodName
    }
  }
}
